import { NgModule } from '@angular/core';

import { Observable, map, expand, EMPTY, filter, take } from 'rxjs';

import { ConfigService } from '../../Core/Config/services/config.service';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { UnifiedStoryRequestModel } from './model/story-request.model';
import { UnifiedStoryResponseModel } from './model/story-response.model';
import { StorySearch } from './model/story-search.model';
import { ServiceApi } from '../genericApi/service-api';
import { StorySearchParams } from './model/story-search-Query-Params.model';
import { StoryResultModel } from './model/story-unified-model';

@NgModule({
    providers: []
})

export class StoryApi {
    constructor(
        private serviceApi: ServiceApi,
        private configurationService: ConfigService
    ) {}

    public createStoryAPI(reqModel: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<UnifiedStoryResponseModel>(
            '/stories/',
            reqModel,
            HttpVerbsEnum.POST
        );
    }

    public updateStoryAPI(id: number, reqModel: UnifiedStoryRequestModel): Observable<UnifiedStoryResponseModel> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<UnifiedStoryResponseModel>(
            '/stories/' + id,
            reqModel,
            HttpVerbsEnum.PUT
        );
    }

    public getStoryListAPI(reqModel: StorySearch, reqQuery: StorySearchParams): Observable<StoryResultModel> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<StoryResultModel>(
            '/stories/search',
            reqModel,
            HttpVerbsEnum.POST,
            reqQuery
        );
    }

    /**
     * get ALL the newsroom stories, but the BE only allows a max of 100 at a time so
     * we recursively get the api call until all stories returned
     */
    public getAllStories(reqModel: StorySearch, reqQuery: StorySearchParams): Observable<StoryResultModel> {
        // recusively gets the story list with expand
        return this.getStoryListAPI(reqModel, reqQuery).pipe(
            expand((results) => {
                // leave exit when met
                if (results.totalCount <= results.stories.length) {
                    return EMPTY;
                }

                reqQuery.start += reqQuery.rows;
                return this.getStoryListAPI(reqModel, reqQuery).pipe(
                    map((innerResults) => {
                        results.stories.push(...innerResults.stories);
                        results.totalCount = innerResults.totalCount;
                        return results;
                    })
                );
            }),
            filter((results) => results.stories.length >= results.totalCount),
            take(100) // Backup to stop over-fetching if issues
        );
    }

    public getStoryAPI(id: number): Observable<UnifiedStoryResponseModel>  {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<UnifiedStoryResponseModel>(
            `/stories/${id}`,
            {},
            HttpVerbsEnum.GET
        );
    }

    public deleteStoryAPI(storyId: string): Observable<string> {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<string>(
            '/stories/' + storyId,
            null,
            HttpVerbsEnum.DELETE
        );
    }

    public deleteStoriesAPI(
        reqModel: number[]
    ) {
        this.serviceApi.apiUrl = this.configurationService.getConfig().apiUrl;

        return this.serviceApi.api<string>(
            '/stories/',
            reqModel,
            HttpVerbsEnum.DELETE
        );
    }

    /*
     * Get image blob
     *
     * @param {string} url
     * @returns {Observable<Blob>}
     */
    public getImage(
        url: string
    ): Observable<Blob> {
        return this.serviceApi.getImageApi(url);
    }
}
